import { render, staticRenderFns } from "./PreviewProjectionsTable.vue?vue&type=template&id=0d0a1790&scoped=true&"
import script from "./PreviewProjectionsTable.vue?vue&type=script&lang=js&"
export * from "./PreviewProjectionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProjectionsTable.vue?vue&type=style&index=0&id=0d0a1790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a1790",
  null
  
)

export default component.exports